import { useState } from "react";
import { Card, Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { PassFailSelect } from "../components/PassFailSelect";
import checkbox_resolved from "../images/inspection_form/checkbox_resolved.png"
import { Image, TextParagraph, X, Check, CodeSlash, ChevronExpand, ChevronContract, ChevronUp, ChevronDown, ChevronRight } from "react-bootstrap-icons";
import { CameraToggleButton, CameraPhotoList } from "../components/CameraPhoto";
import { useTransition, animated } from '@react-spring/web';
import { easings } from '@react-spring/web'


export function SurveyQuestion(props) {
	// Basic Setup
	let { inspection, questionMeta, saveAction, onChange, sectioned } = props;
	let question = questionMeta.question;
	let qid = question.id;
	let response = inspection.getResponseFor(qid);
	let hasPassButton = !question.commentsOnly;
	
	// State variables
	let [cameraActive, setCameraActive] = useState(false);
	let [photoList, setPhotoList] = useState(inspection.getResponsePhotosFor(qid));
	
	let [collapsed, setCollapsed] = useState(!question.commentsOnly);
	let [responseVal, setResponseVal] = useState(response.value);
	response.value = responseVal;
	
	const [hasOpened, setHasOpened] = useState(false);
	const [clickedButton, setClickedButton] = useState(false);
	const [didButtonTransition, setDidButtonTransition] = useState(false);
	const [didCheckTransition, setDidCheckTransition] = useState(false);
	
	let updateInspectionComment = (evt) => {
		inspection.setResponseCommentsFor(qid, evt.target.value);
		onChange?.();
	};

	let receivePhotoData = (dataUri) => {
		inspection.addResponsePhotoFor(qid, dataUri);
		setPhotoList(inspection.getResponsePhotosFor(qid));
		saveAction?.();
	};
	
	let deletePhoto = (ph) => () => {
		if(confirm("Are you sure you want to delete this photo?")) {
			inspection.removeResponsePhotoFor(qid, ph);
			setPhotoList(inspection.getResponsePhotosFor(qid));	
			saveAction?.();
		}
	};
	
	
	let getResponseIcon = () => {
		if(responseVal == null){
			return <Button onClick={function(e) {e.stopPropagation(); setResponseVal("PASS"); setClickedButton(true); onChange?.()}}>Pass</Button>;
		} else if (responseVal == "PASS"){
			return <Check className={clickedButton && !didCheckTransition? "drawLTR": ""} onAnimationEnd={() => {setDidCheckTransition(true)}} color="green" />;
		} else if (responseVal == "FAIL"){
			return <X color="red" />;
		} else if (responseVal == "RESOLVED"){
			return <img style={{height:"20px"}} src={checkbox_resolved}/>;
		} else if (responseVal == "NA"){
			return <CodeSlash color="orange" />;
		}
	}


	const transitions = useTransition(getResponseIcon(),
		{
		 from: { opacity: 1, x:0 },
		 enter: { opacity: 1, x:0 },
		 leave: () => {
			return {opacity: 0, x:0};
		},
		onDestroyed: () => {
			if(clickedButton){
				setDidButtonTransition(true);
			}
			if((!collapsed && !hasOpened)){
				setDidButtonTransition(true);
			}
		},
		 exitBeforeEnter: true,
		 config: {
			easing: easings.easeInSine,
			duration: 250
		 }
	   });
	 



	let cameraButton = <CameraToggleButton isCameraActive={cameraActive} setIsCameraActive={setCameraActive} />;
	let willAllowAnimation =  clickedButton && !didButtonTransition;

	return (
		<Card className="mt-3">
			<Card.Header className="toggable" onClick={() => {setCollapsed(!collapsed); if(collapsed) {setHasOpened(true)} }}>
				<Card.Title className="flex">
					<div className={collapsed ? "textAlignLeft textAlignVerticalCenter" : "textAlignCenter"}>{question.name}</div>
					<div>
						{collapsed && <div className="float-end">
							
							{hasPassButton &&((willAllowAnimation)? transitions((style, item) => ( <animated.div className="float-start" style={style}>{item}</animated.div> )) : getResponseIcon()) }
							<TextParagraph color={!!(response.comments) ? "black" : "lightgray"} className="d-none d-sm-inline ms-3" />
							<Image color={response.photos.length == 0 ? "lightgray" : "black"} className="d-none d-sm-inline ms-3" />
							<span className={`numeric-alert-inline ${response.photos.length == 0 && 'invisible'}`}>{response.photos.length}</span>
						</div>}
					</div>
					
				</Card.Title>	
			</Card.Header>
			<Card.Body className={`${collapsed ? "collapse" : ""}`}>
				<div className="mb-2">
					{question.commentsOnly && cameraButton}
					{question.question}
				</div>

				<div className="mb-2 camera_container">
						{!question.commentsOnly && cameraButton} {/* Camera button looks better inline with PFS if PFS is present, otherwise it shouldn't be its own row if it is comments-only */}
						{!question.commentsOnly && <PassFailSelect defaultValue={responseVal} skippable={question.skippable} resolvable={question.resolvable} saveAction={saveAction}
						onChange={(val) => { onChange(); setResponseVal(val)}} />}
						{/*{question.pngImage && <img style={{"backgroundColor": "#007041", "border": "1px solid black"}} src={`images/survey/${question.pngImage}.svg`} width="35" height="35" />}*/}
				</div>

				<CameraPhotoList isCameraActive={cameraActive} receivePhotoDataAction={receivePhotoData} deletePhotoAction={deletePhoto} photoList={photoList} />

				<Form.Control as="textarea" className="mt-3" rows={3} name={`question_${qid}_comments`} onChange={updateInspectionComment} defaultValue={response.comments}></Form.Control>

			</Card.Body>
		</Card>
	);
}